module.exports = __webpack_public_path__ + "static/media/earnings.35eb24d3.svg";